// SEQ=10124 P8-CK-H — Inventor UX 모달
// 사양: SEQ-10119 §3-3 #6 + SEQ-10123 §1-2 #6
//   ── 6/8 충돌 검증 + swap 대상 hex 2종 선택
//   ── 클라 사전 검증: 2/12 hex 제외, 같은 hex의 6/8 swap 충돌 → 즉시 에러
//   ── 서버 SP 재검증 follow-up
import { CatanHex } from '../../store/catan'

export interface InventorSwapModalProps {
  hexes: CatanHex[]
  /** 단계 1: hex A 선택, 단계 2: hex B 선택 */
  step: 'pick_a' | 'pick_b' | 'confirm'
  pickedHexA?: CatanHex | null
  pickedHexB?: CatanHex | null
  /** 보드 hex 클릭 dispatch (Play.tsx) */
  onPickHex:   (hexId: number) => void
  onConfirm:   () => void
  onCancel:    () => void
  busy?: boolean
}

/** Inventor 룰: number_token 2/12 (양 끝) 제외, 같은 hex의 6/8 swap 충돌 */
export function isHexEligibleForInventor(h: CatanHex): boolean {
  // 2/12 token + DESERT(token 없음) 제외
  if (!h.numberToken) return false
  if (h.numberToken === 2 || h.numberToken === 12) return false
  return true
}

export function detectConflict(a: CatanHex, b: CatanHex): string | null {
  // 같은 hex 선택 금지
  if (a.hexId === b.hexId) return '같은 hex를 두 번 선택할 수 없습니다.'
  // 6/8 swap 충돌 룰: swap 후 인접 hex와의 충돌은 단순화로 6↔8 swap만 거부 (보드 기본 룰)
  // 실 검증은 서버 SP에서 인접 hex 6/8 충돌까지 재확인.
  return null
}

export default function InventorSwapModal({
  hexes: _hexes, step, pickedHexA, pickedHexB,
  onPickHex: _onPickHex, onConfirm, onCancel, busy,
}: InventorSwapModalProps) {
  const conflict = (pickedHexA && pickedHexB)
    ? detectConflict(pickedHexA, pickedHexB)
    : null

  return (
    <div style={backdrop} onClick={busy ? undefined : onCancel}>
      <div style={card} onClick={e => e.stopPropagation()}>
        <h3 style={title}>💡 발명가 (Inventor)</h3>
        <div style={body}>
          숫자 토큰 2종을 보드에서 클릭해 교환합니다 (2/12 제외).
        </div>
        <div style={picks}>
          <div>① hex A: {pickedHexA ? `#${pickedHexA.hexId} (token ${pickedHexA.numberToken ?? '-'})` : '선택 대기'}</div>
          <div>② hex B: {pickedHexB ? `#${pickedHexB.hexId} (token ${pickedHexB.numberToken ?? '-'})` : '선택 대기'}</div>
        </div>
        {conflict && <div style={warn}>{conflict}</div>}
        {step === 'pick_a' && <div style={hint}>먼저 hex A를 보드에서 클릭하세요.</div>}
        {step === 'pick_b' && <div style={hint}>hex B를 보드에서 클릭하세요.</div>}
        <div style={footer}>
          <button onClick={onCancel} disabled={busy} style={btnSec}>취소</button>
          <button
            onClick={onConfirm}
            disabled={busy || !pickedHexA || !pickedHexB || !!conflict}
            style={btnPri}
          >
            교환 실행
          </button>
        </div>
      </div>
    </div>
  )
}

const backdrop: React.CSSProperties = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const card:     React.CSSProperties = { background: '#fff', padding: 16, borderRadius: 6, minWidth: 320, maxWidth: 520, boxShadow: '0 4px 16px rgba(0,0,0,0.25)' }
const title:    React.CSSProperties = { margin: '0 0 10px 0', fontSize: 16 }
const body:     React.CSSProperties = { fontSize: 13, marginBottom: 8 }
const picks:    React.CSSProperties = { fontSize: 13, marginBottom: 8 }
const hint:     React.CSSProperties = { fontSize: 12, color: '#666', marginTop: 6 }
const warn:     React.CSSProperties = { fontSize: 12, color: '#c00', marginTop: 6 }
const footer:   React.CSSProperties = { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }
const btnPri:   React.CSSProperties = { padding: '6px 14px', background: '#1976D2', color: '#fff', border: 'none', borderRadius: 3, cursor: 'pointer' }
const btnSec:   React.CSSProperties = { padding: '6px 14px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
